import { LocalStorage } from "../LocalStorage";
import { companySlug } from "../URLHandler";
import { switchUrl } from "../urlSwitcher";

export type CompanyMandatoryFields = {
    "@id": string;
    id: number;
    name: string;
    organisation?: string;
    organizationSector?: {
        id: number;
        name: string;
    };
    isProvider: boolean;
};

export class CompaniesService {
    static getCurrentCompanyId(): number | null {
        const companyId = LocalStorage.getItem("company");
        if (companyId === null) {
            return null;
        }
        return Number(companyId);
    }

    static switchCompany(companyId: number) {
        LocalStorage.setItem("company", companyId.toString());
    }

    static resetCompany() {
        LocalStorage.deleteItem("company");
    }

    static isCompanyIdValid(companyId: number | null, allCompanies: CompanyMandatoryFields[]): boolean {
        if (companyId === null) {
            return false;
        }

        const foundCompany = allCompanies.findIndex((company) => company.id === companyId);
        if (foundCompany === -1) {
            return false;
        }
        return true;
    }

    static selectCurrentCompany<T extends CompanyMandatoryFields>(allCompanies: T[], companyId?: number): T | null {
        const currentId = companyId === undefined ? this.getCurrentCompanyId() : companyId;

        const selectedCompany = allCompanies.find((company) => company.id === currentId);

        if (selectedCompany === undefined) {
            return null;
        }

        this.switchCompany(selectedCompany.id);
        return selectedCompany;
    }

    static switchCompanyURL(companyId: number, currentUrl: string) {
        const newUrl = switchUrl({
            url: currentUrl,
            options: [{ slug: companySlug, newId: companyId }],
        });

        return newUrl;
    }
}
